<template>
  <div>
    <div class="inner-header ">
      <nav class="navbar fixed-top bg-white animate__animated animate__slideInRight">
        <a  @click="$router.go(-1)" class="back-arrow">
            <svg xmlns="http://www.w3.org/2000/svg" width="17.368" height="16.365" viewBox="0 0 17.368 16.365">
               <g id="Group_38360" data-name="Group 38360" transform="translate(-27.632 -34.814)" opacity="1">
                  <line id="Line_124" data-name="Line 124" x2="16" transform="translate(29 43)" fill="none" stroke="#000" stroke-width="2"/>
                  <path id="Path_51451" data-name="Path 51451" d="M.033,0l-7,7.425L.033,15" transform="translate(35.967 35.5)" fill="none" stroke="#000" stroke-width="2"/>
               </g>
            </svg>
         </a>
         <a href="javascript:void(0);" class="link-title">Edit Meeting</a>
      </nav>
    </div>
    <div class="inner-page bg-white animate__animated animate__slideInRight">
        <div class="container-fluid">
            <div class="row">
                <!-- Enquiry Card -->
                <div class="col-12">
                    <div class="card details-card form-card">
                        <div class="card-body p-0">
                            <div class="row">
                               <div class="col-12">
                                    <span class="lead-heading mt-4 mb-4">Enter Meeting Details</span>
                                </div>
                                <div class="col-12">
                                    <b-form @submit.prevent="EditMeetingDetails">
                                      <!-- <b-form-group class="form-group  mb-4p-0 ">
                                        <label for="firmName">Select Broker<span class="text-danger">*</span></label>
                                        <multiselect v-model="brokerSelected" :searchable="true" placeholder="Select Broker" label="name" class="form-multiselect" ref="brokerselect" track-by="id" :options="firmList" :multiple="false" :taggable="false" @input="selectBroker"></multiselect>
                                      </b-form-group> -->
                                        <!-- <b-form-group>
                                          <label>Field Executive<span class="text-danger">*</span></label>
                                           <multiselect v-model="EditMeeting.user_id" :searchable="true" placeholder="Select Field Executive" label="text" class="form-multiselect" ref="multiselect" track-by="value" :options="FieldExecutiveList" :multiple="false" :taggable="false" @input="updateFieldRequired"></multiselect>
                                        </b-form-group> -->
                                        <template v-if="!isFromMyMeetings">
                                          <b-form-group>
                                            <label>Start Date And Time<span class="text-danger">*</span></label>
                                            <datetime type="datetime" v-model="EditMeeting.start_date" @input="setEndDate(EditMeeting.start_date)" placeholder="Start Date And Time" required :disabled="Number(roleid) !== 1"></datetime>
                                          </b-form-group>
                                          <b-form-group>
                                            <label>End Date And Time<span class="text-danger">*</span></label>
                                            <datetime type="datetime" v-model="EditMeeting.end_date" placeholder="End Date And Time" required :disabled="Number(roleid) !== 1"></datetime>
                                          </b-form-group>
                                        </template>
                                        <template v-if="isFromMyMeetings">
                                          <b-form-group>
                                            <label>Start Date And Time<span class="text-danger">*</span></label>
                                            <datetime type="datetime" v-model="EditMeeting.start_date" @input="setEndDate(EditMeeting.start_date)" placeholder="Start Date And Time" required disabled></datetime>
                                          </b-form-group>
                                          <b-form-group>
                                            <label>End Date And Time<span class="text-danger">*</span></label>
                                            <datetime type="datetime" v-model="EditMeeting.end_date" placeholder="End Date And Time" required disabled></datetime>
                                          </b-form-group>
                                        </template>
                                        <b-form-group label="" v-if="!isFromMyMeetings">
                                          <label>Meeting Type<span class="text-danger">*</span></label>
                                          <b-form-select v-model="EditMeeting.meeting_type" required :options="meetingTypesList"></b-form-select>
                                        </b-form-group>
                                        <b-form-group label="" v-if="isFromMyMeetings">
                                          <label>Meeting Type<span class="text-danger">*</span></label>
                                          <b-form-select v-model="EditMeeting.meeting_type" required :options="meetingTypeListFromMyMeeting"></b-form-select>
                                        </b-form-group>
                                        <!-- <b-form-group>
                                          <label>Select Rating<span class="text-danger">*</span></label>
                                          <b-form-rating v-model="EditMeeting.rating_to_broker" required></b-form-rating>
                                        </b-form-group> -->
                                          <b-form-group label="" v-if="!isFromMyMeetings">
                                            <label for="firmName">App Engagement<span class="text-danger">*</span></label>
                                            <b-form-select v-model="EditMeeting.app_engagement" required>
                                            <b-form-select-option :value="null" selected disabled>Select One</b-form-select-option>
                                            <b-form-select-option :value='true'>Yes</b-form-select-option>
                                            <b-form-select-option :value='false'>No</b-form-select-option>
                                          </b-form-select>
                                          </b-form-group>
                                          <b-form-group label="" v-if="EditMeeting.app_engagement == false">
                                            <label>Reason of No App Engagement<span class="text-danger">*</span></label>
                                            <b-form-textarea v-model="EditMeeting.no_app_engagement_comments" :required="EditMeeting.app_engagement == false" placeholder="Reason of No App Engagement" rows="3" max-rows="6"></b-form-textarea>
                                          </b-form-group>
                                            <b-form-group v-if="EditMeeting.app_engagement == true">
                                              <label>No of Resale & Rental Listing<span class="text-danger">*</span></label>
                                              <b-form-input type="number" v-model="EditMeeting.listing_count" :required="EditMeeting.app_engagement == true" placeholder="No of Resale & Rental Listing"></b-form-input>
                                          </b-form-group>
                                          <b-form-group v-if="EditMeeting.app_engagement == true">
                                              <label>No of Enquiry Count<span class="text-danger">*</span></label>
                                              <b-form-input type="number" v-model="EditMeeting.lead_count" :required="EditMeeting.app_engagement == true" placeholder="No of Enquiry Count"></b-form-input>
                                          </b-form-group>
                                          <b-form-group v-if="EditMeeting.app_engagement == true">
                                              <label>Syndicate Networking Requirement<span class="text-danger">*</span></label>
                                              <b-form-input type="number" v-model="EditMeeting.requirement_count" :required="EditMeeting.app_engagement == true" placeholder="Syndicate Networking Requirement"></b-form-input>
                                          </b-form-group>
                                        <b-form-group label="" v-if="!isFromMyMeetings">
                                            <label>Minutes of meeting<span class="text-danger">*</span></label>
                                            <b-form-textarea placeholder="Add minutes of meeting " required v-model="EditMeeting.comment" rows="3" max-rows="6" ></b-form-textarea>
                                        </b-form-group>
                                        <b-form-group label="" v-if="isFromMyMeetings">
                                            <label>Minutes of meeting<span class="text-danger">*</span></label>
                                            <b-form-textarea placeholder="Add minutes of meeting " required v-model="EditMeeting.minutes_of_meeting" rows="3" max-rows="6" ></b-form-textarea>
                                        </b-form-group>
                                        <b-form-group v-if="!isFromMyMeetings">
                                            <label>My Location<span class="text-danger">*</span></label>
                                            <b-form-input type="text" v-model="EditMeeting.location" readonly required placeholder="Find My Location"></b-form-input>
                                        </b-form-group>
                                        <div class="card-btn v-align-center " v-if="!isFromMyMeetings">
                                          <button class="btn btn-white btn-block border text-center h-auto mt-2 mb-4 p-3" type="button" @click="AddUpdateCampaign()">
                                          <b-icon pill class="" icon="plus"></b-icon> Add Campaign </button>
                                        </div>
                                          <div class="table-responsive" v-if="!isFromMyMeetings">
                                            <table
                                              class="table table-bordered datatablesB4 projectList elevation-3">
                                              <thead>
                                                <tr>
                                                  <th style="width:70%">Title</th>
                                                  <th> Action</th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                 <tr v-for="(item, key) in Campaigns" :key="key" >
                                                  <td>{{item.title}}</td>
                                                    <td>
                                                      <b-button  size="sm" type="button" @click="AddUpdateCampaign(item)" class="btn-white-small"><img src="@/assets/edit-orange.svg" alt=""></b-button>
                                                      <b-button  size="sm" type="button" @click="DeleteCampaign(item)" class="btn-white-small"><img src="@/assets/delete.svg" alt=""></b-button>
                                                    </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </div>
                                      <b-form-group class="mt-5">
                                        <b-button variant="primary" type="submit" block>Save</b-button>
                                      </b-form-group>
                                    </b-form>
                                </div>
                                <!-- Add Cmapaign  -->
                                <b-modal hide-footer  title="Add Campaign" v-model="showCampaignModel"
                                 @hidden="AddCampaign = {}">
                                  <div class="bg-white animate__animated animate__slideInRight">
                                    <div class="row">
                                        <div class="col-12">
                                            <div class="card details-card form-card">
                                                <div class="card-body p-0 mt-0">
                                                    <div class="row">
                                                      <div class="col-12">
                                                        <b-form @submit.prevent="AddNewCampiagn(AddCampaign)">
                                                          <b-form-group>
                                                            <label>Project Name<span class="text-danger">*</span></label>
                                                            <multiselect v-model="AddCampaign.building_id" :searchable="true" placeholder="Select Project" label="text" class="form-multiselect" track-by="value" :options="ProjectList" :multiple="false" :taggable="false"></multiselect>
                                                        </b-form-group>
                                                        <b-form-group>
                                                          <label>Start Date<span class="text-danger">*</span></label>
                                                            <datetime type="date" v-model="AddCampaign.start_date" required placeholder="Start Date">
                                                            </datetime>
                                                        </b-form-group>
                                                        <b-form-group>
                                                          <label>End Date<span class="text-danger">*</span></label>
                                                            <datetime type="date" v-model="AddCampaign.end_date" required placeholder="End Date">
                                                            </datetime>
                                                        </b-form-group>
                                                        <b-form-group>
                                                          <label>Campaign Type<span class="text-danger">*</span></label>
                                                            <b-form-select v-model="AddCampaign.campaign_type" required :options="CamapaignTypes">
                                                            </b-form-select>
                                                        </b-form-group>
                                                        <b-form-group>
                                                            <label>Title<span class="text-danger">*</span></label>
                                                            <b-form-input type="text" v-model="AddCampaign.title" required placeholder="Title"></b-form-input>
                                                        </b-form-group>
                                                        <b-form-group>
                                                          <label>Planned Outreach<span class="text-danger">*</span></label>
                                                            <b-form-input type="text" v-model="AddCampaign.compaign_data" required placeholder="Target"></b-form-input>
                                                        </b-form-group>
                                                        <b-form-group>
                                                            <label>Achieved<span class="text-danger">*</span></label>
                                                            <b-form-input type="number" v-model="AddCampaign.achieved" :required="AddCampaign.executed === 'true'" placeholder="0"></b-form-input>
                                                        </b-form-group>
                                                        <b-form-group>
                                                          <label>Enquiries / Hot<span class="text-danger">*</span></label>
                                                            <b-form-input type="number" v-model="AddCampaign.enquiries_count" :required="AddCampaign.executed === 'true'" placeholder="0"></b-form-input>
                                                        </b-form-group>
                                                        <b-form-group>
                                                          <label>Comment<span class="text-danger">*</span></label>
                                                          <div class= "campaign-comment" v-html="AddCampaign.comment ? AddCampaign.comment.trim():''"></div>
                                                            <b-form-textarea v-model="AddCampaign.executive_comments" required placeholder="Description" rows="3" max-rows="6">
                                                            </b-form-textarea>
                                                        </b-form-group>
                                                        <b-form-group>
                                                            <b-form-checkbox v-model="AddCampaign.executed" value="true"
                                                                unchecked-value="false"><span class="name mt-1">Executed</span>
                                                            </b-form-checkbox>
                                                        </b-form-group>
                                                        <b-form-group class="mt-3">
                                                            <b-button type="submit" variant="primary" block>Save</b-button>
                                                        </b-form-group>
                                                    </b-form>
                                                      </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                  </div>
                              </b-modal>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>
</template>
<script>
import {decodeEditMeetingParams} from '@/assets/scripts/utility.js';
import { Datetime } from 'vue-datetime';
import Multiselect from 'vue-multiselect'

export default {
  name: 'EditMeeting',
  components: {
    datetime: Datetime,
    Multiselect
  },
  data() {
    return {
			Campaigns: [],
			DeletedCampaigns: [],
			ProjectList: [],
			EditMeeting: {},
      showCampaignModel: false,
      meetingTypeListFromMyMeeting: [],
      AddCampaign: {
        start_date: null,
        end_date: null,
        campaign_type: null,
        title: null,
        achieved: null,
        enquiries_count: null,
        building_id: null,
        compaign_data: null,
        comment: null,
        executed: false,
        _destroy: false,
        IUD: 'I',
        isFromMyMeetings: false,
      },
      brokerSelected: {
        id:null,
        name:'Select Broker'
      },
      GetS3Discussion: [{ value: null, text: 'Select One' },
       {value: true, text: 'Yes'},
       {value: false, text: 'No'}]
    }
  },
  mounted(){
    this.getMeetingTypeList();
    this.isFromMyMeetings = JSON.parse(sessionStorage.getItem("isFromMyMeetings"));
    let brokers = []
    this.$store.getters.brokersMaster.forEach(broker => {
      brokers.push({id: broker.value, name: broker.text})
    })
    this.brokers = brokers;
    this.updateFieldRequired();
    this.selectBroker();
    this.GetMeetingDetailsONEdit(this.$route.params.id);
  },
  computed: {
    FieldExecutiveList() {
      return this.$store.getters.FieldExecutiveMaster;
    },
    CamapaignTypes() {
      return this.$store.getters.CampaignTypesMaster;
    },
    firmList() {
      let brokers = []
      this.$store.getters.BrokersFirmNameMaster.forEach(broker => {
        brokers.push({id: broker.value, name: broker.text})
      })
      return brokers;
    },
    meetingTypesList(){
      return this.$store.getters.MeetingTypesMaster;
    },
    roleid(){
      return localStorage.getItem('radiate-crm-role_id')
    }
  },
  methods: {
  setEndDate (start_date) {
     this.EditMeeting.end_date = start_date
  },
  AddUpdateCampaign(row) {
    if (row === undefined) {
      this.showCampaignModel = true
      this.AddCampaign.IUD = 'I'
    } else if (row.building_id !== null) {
      this.AddCampaign = row
      if (this.AddCampaign.building_id) {
        this.AddCampaign.building_id = {value: row.building_id, text: row.building_name}
      }
      this.AddCampaign.IUD = 'U'
      this.showCampaignModel = true
    }
  },
  AddNewCampiagn(row) {
    if (row.IUD === 'I') {
      this.Campaigns.push(row)
      this.showCampaignModel = false
      this.AddCampaign = {}
    } else {
      this.showCampaignModel = false
      this.AddCampaign = {}
    }
  },
  DeleteCampaign(row) {
		row._destroy = 1
		this.DeletedCampaigns.push(row)
    this.Campaigns.splice(this.Campaigns.indexOf(row), 1)
  },
  getMeetingTypeList() {
    this.$axios.get("/enquiries/client_meetings/settings", {
      headers: {
          'Content-Type': 'multipart/form-data'
      }
    })
    .then((res) => {
        // this.meetingTypesList = res;
      for(var i=0;i<Object.keys(res.data.meeting_types).length;i++) {
          this.meetingTypeListFromMyMeeting.push({"text": Object.keys(res.data.meeting_types)[i], "value":Object.keys(res.data.meeting_types)[i] })
      }
    })
    .catch((err) => {
        console.log(err);
    });
  },
  GetMeetingDetailsONEdit(MeetingId) {
		let queryP = {}
    queryP['id'] = MeetingId;
    if(!this.isFromMyMeetings) {
      this.$axios.get(`users/meetings/${queryP.id}/meeting_detail`, { params: queryP }).then((res) => {
        this.EditMeeting =  res.data.meeting
        this.EditMeeting.user_id = {text:res.data.meeting.username, value:res.data.meeting.user_id};
        this.brokerSelected = {id: res.data.meeting.broker_id, name: res.data.meeting.name_with_firm_name};
        this.updateFieldRequired();
        this.selectBroker();
        this.Campaigns = res.data.campaign_data;
        this.getProjects();
      });
    } else {
      this.$axios.get(`enquiries/client_meetings/${queryP.id}/client_meeting_detail?id=${queryP.id}`).then((res) => {
        this.EditMeeting =  res.data.client_meeting
        this.EditMeeting.user_id = {text:res.data.client_meeting.field_executive, value:res.data.client_meeting.id};
        this.brokerSelected = {id: res.data.client_meeting.id, name: res.data.client_meeting.broker_name};
        // this.EditMeeting.start_date = res.data.client_meeting.start_date_time;
        // this.EditMeeting.end_date = res.data.client_meeting.end_date_time;
        // this.updateFieldRequired();
        // this.selectBroker();
        // this.Campaigns = res.data.campaign_data;
        // this.getProjects();
      });
    }
  },
  getProjects() {
    this.ProjectList = []
    let queryP = {}
    queryP['broker_id'] = this.brokerSelected.id
    this.$axios.get(`users/meetings/projects_for_new_campaign`, { params: queryP }).then((res) => {
      res.data.projects.forEach((item,index) => {
        this.ProjectList.push({value: item.id, text: item.name})
      });
      this.ProjectList.unshift({value: null, text: 'Select Project'})
    });
  },
  EditMeetingDetails() {
    if(!this.isFromMyMeetings) {
      this.EditMeeting.broker_id = this.brokerSelected.id
      if (this.DeletedCampaigns.length > 0) {
        for (var value of this.DeletedCampaigns) {
          this.Campaigns.push(value)
        }
      }
      let apiParams = decodeEditMeetingParams(this.EditMeeting, this.Campaigns);
      this.$axios
        .put(`/users/meetings/${this.$route.params.id}`, { users_meeting  : apiParams })
        .then((res) => {
          swal({
            title: "Meeting Updated!",
            icon: "success",
          }).then(this.$router.replace({ name: "MeetingDetails", params: {id: this.$route.params.id } }));
        })
        .catch((err) => {
          if (err.response.status === 500) {
            swal({
              title: "Server Error!",
              icon: "error",
            });
          } else {
            swal({
              title: "Error",
              text: err.response.data.message,
              icon: "error",
            });
          }
        });
      }else if(this.isFromMyMeetings){
        delete this.EditMeeting.broker_name, this.EditMeeting.client_name, this.EditMeeting.project_name,
                this.EditMeeting.comment, this.EditMeeting.end_date_time, this.EditMeeting.enquiry_no,
                this.EditMeeting.meeting_comment;
        let apiParams = decodeEditMeetingParams(this.EditMeeting);
        this.$axios
          .put(`/enquiries/client_meetings/${this.$route.params.id}`,  apiParams)
          .then((res) => {
            swal({
              title: "Meeting Updated!",
              icon: "success",
            }).then(this.$router.replace({ name: "MeetingDetails", params: {id: this.$route.params.id } }));
          })
          .catch((err) => {
            if (err.response.status === 500) {
              swal({
                title: "Server Error!",
                icon: "error",
              });
            } else {
              swal({
                title: "Error",
                text: err.response.data.message,
                icon: "error",
              });
            }
          });
      }
    },
    selectBroker() {
      this.$nextTick(()=> {
        if(this.$refs.brokerselect){
          this.$refs.brokerselect.$el.querySelector('input').required = !this.brokerSelected || !this.brokerSelected.id;
        }
      });
    },
    updateFieldRequired() {
      this.$nextTick(() => {
        this.$refs.multiselect.$el.querySelector('input').required = !this.EditMeeting.user_id || !this.EditMeeting.user_id.value;
        });
      }
  },

}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.bgcolor {
  background: #f58321;
  color: white
}
table{
      font-size: 12px;
    font-weight: 400;
}
.btn-white-small{
  padding: 4px 8px;
  background: #fff;
  border: 1px solid #dfdfdf;
  margin-right: 5px;
}
.campaign-comment{
  white-space: pre-line;
}
</style>